export interface State {
	isMaximized?: boolean;
	normalBounds?: Electron.Rectangle;
}

export interface Action {
	SET_IS_MAXIMIZED: (isMaximized: State["isMaximized"]) => void;
	SET_NORMAL_BOUNDS: (normalBounds: State["normalBounds"]) => void;
	update: (e: Partial<State>) => void;
}

export const getInitialState = (): State => {
	return {
		isMaximized: undefined,
		normalBounds: undefined,
	};
};

export const getInitialAction = (set: any): Action => {
	return {
		SET_IS_MAXIMIZED: (isMaximized) => {
			set(() => ({ isMaximized }));
		},
		SET_NORMAL_BOUNDS: (normalBounds) => {
			set(() => ({ normalBounds }));
		},
		update: (state) => {
			set(() => state);
		},
	};
};

export const storeName = "store:app";

export type PersistedState = Pick<State, "isMaximized" | "normalBounds">;

export const partialize = (state: State & Action): PersistedState => {
	const { isMaximized, normalBounds } = state;
	return { isMaximized, normalBounds };
};
